<template>
  <section class="bg-tw-sand" aria-labelledby="features-heading">
    <div class="mx-auto flex max-w-[1280px] flex-col gap-12 px-6 py-20 md:px-[98px] md:py-[103px] lg:flex-row lg:justify-between">
      <div class="max-w-[437px]">
        <h2 id="features-heading" class="text-4xl tracking-[-0.02em] text-black md:text-[45px] md:leading-[1.2]">{{ t('heading') }}</h2>
        <p class="mt-4 text-xl leading-8 text-tw-ink md:text-[25px]">{{ t('lead') }}</p>
      </div>
      <dl class="flex max-w-[620px] flex-col lg:w-[620px] lg:shrink-0 gap-12 text-tw-ink">
        <div v-for="key in ['explore', 'contribute', 'keep']" :key="key">
          <dt class="text-2xl leading-7 md:text-3xl">{{ t(`${key}.title`) }}</dt>
          <dd class="mt-4 max-w-[571px] text-lg leading-8 md:text-xl">{{ t(`${key}.text`) }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n({
    messages: {
      no: {
        heading: 'Laget for gode samtaler.',
        lead: 'En felles tavle gir plass til flere tanker, perspektiver og ideer.',
        explore: {
          title: 'Utforsk ideer sammen',
          text: 'Læreren lager oppgaver, stiller spørsmål og leder samtalen. Elever og studenter kan delta med kallenavn og en felles PIN-kode, eller logge inn med Feide.',
        },
        contribute: {
          title: 'La alle bidra',
          text: 'Jobb individuelt, i grupper eller i plenum, og bygg videre på hverandres bidrag. Skriftlige innlegg gir også rom for dem som kvier seg for å delta muntlig.',
        },
        keep: {
          title: 'Ta vare på ideene og bygg felles forståelse',
          text: 'Samle bidragene på en stor skjerm. Organiser, diskuter og videreutvikle dem sammen, slik at ideene blir med videre i samtalen.',
        },
      },
      en: {
        heading: 'Made for good conversations.',
        lead: 'A shared wall makes room for more thoughts, perspectives and ideas.',
        explore: {
          title: 'Explore ideas together',
          text: 'The teacher creates tasks, asks questions and leads the conversation. Pupils and students can join with a nickname and a shared PIN code, or log in with Feide.',
        },
        contribute: {
          title: 'Let everyone contribute',
          text: "Work individually, in groups or as a whole class, and build on each other's contributions. Written posts also make room for those who hesitate to speak up.",
        },
        keep: {
          title: 'Keep the ideas and build shared understanding',
          text: 'Gather the contributions on a big screen. Organise, discuss and develop them together, so the ideas carry forward in the conversation.',
        },
      },
    },
  })
</script>
